import type en from '../en/nav'
import type { Translation } from '../types'

/** The menu and the frame around every page */
const nav: Translation<typeof en> = {
  "nav.overview": "Resumen",
  "nav.admins": "Administradores",
  "nav.models": "Modelos",
  "nav.companies": "Empresas",
  "nav.settings": "Configuración",
  "nav.vpn": "VPN",
  "nav.edge": "Proxy perimetral",
  "nav.licensePlans": "Planes de licencia",
  "nav.licenseOverview": "Resumen de licencias",
  "nav.myProfile": "Mi perfil",
  "nav.dashboard": "Panel",
  "nav.monitoring": "Monitorización",
  "nav.alerts": "Alertas",
  "nav.sites": "Sitios",
  "nav.templates": "Plantillas",
  "nav.users": "Usuarios",
  "nav.roles": "Roles",
  "nav.branding": "Marca",
  "nav.messages": "Mensajes",
  "nav.apiKeys": "Claves de API",
  "nav.webhooks": "Webhooks",
  "nav.notifications": "Notificaciones",
  "nav.roleGlobalAdmin": "Administrador global",
  "nav.roleAdmin": "Administrador",
  "nav.roleUser": "Usuario",
  "nav.switchCompany": "Cambiar de empresa",
  "nav.logout": "Cerrar sesión",
  "nav.expand": "Expandir",
  "nav.collapse": "Contraer",
  "nav.expandMenu": "Expandir el menú",
  "nav.collapseMenu": "Contraer el menú",
  "nav.openMenu": "Abrir el menú",
  "nav.closeMenu": "Cerrar el menú",
  "nav.licenseExpired": "Su licencia ha caducado. El panel es de solo lectura hasta que se renueve.",
  "nav.passwordLeaked": "Su contraseña aparece en una filtración de datos conocida, así que otros podrían probarla.",
  "nav.passwordLeakedChange": "Cámbiela ahora en",
  "nav.rental": "Alquiler",
  "nav.inbox": "Bandeja de entrada",
  "nav.inboxUnread": "Bandeja de entrada, {count} sin leer",
  "nav.inboxReadAll": "Marcar todo como leído",
  "nav.inboxEmpty": "Aún no hay nada",
  "nav.pushRelay": "Reenvío push",
}

export default nav
